import template from './brokerPediaIcon.html';

export default {
  template,
  bindings: {
    bannerText: '@',
  },
};
